import React, { useContext } from 'react';
import SidebarItem from './components/SidebarItem';
import { IRestaurantLocalizationGroup } from 'types';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './Sidebar.module.scss';

interface ISidebar {
	items: IRestaurantLocalizationGroup[];
}

const Sidebar: React.FC<ISidebar> = ({ items }) => {
	const { setLocalizationGroup, selectedLocalizationGroup } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<>
			{items.length ? (
				<div className={style.container}>
					{items.map((el) => (
						<SidebarItem
							key={el.id}
							label={el.name || ''}
							isActive={selectedLocalizationGroup?.id === el.id}
							onClick={() => setLocalizationGroup(el)}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default Sidebar;
